// extracted by mini-css-extract-plugin
module.exports = {"root":"lets-start-module--root--2pzDW","dash":"lets-start-module--dash--2x_vu","wrapper":"lets-start-module--wrapper--OREzR","button":"lets-start-module--button--1fFgM"};